import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a57720"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "document-sidebar first-widget"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-title" }, "List Of Documents", -1))
const _hoisted_3 = {
  key: 0,
  class: "uploading-txt"
}
const _hoisted_4 = { class: "document-ul" }
const _hoisted_5 = { class: "doc-box" }
const _hoisted_6 = { class: "doc-icon" }
const _hoisted_7 = ["alt", "src"]
const _hoisted_8 = { class: "doc-info" }
const _hoisted_9 = { class: "doc-title" }
const _hoisted_10 = { class: "doc-name" }
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = { class: "doc-details" }
const _hoisted_13 = { class: "doc-size" }
const _hoisted_14 = { class: "upload-status" }
const _hoisted_15 = { class: "upload-percent" }
const _hoisted_16 = { class: "doc-progress" }
const _hoisted_17 = { class: "doc-box" }
const _hoisted_18 = { class: "doc-icon" }
const _hoisted_19 = ["alt", "src"]
const _hoisted_20 = { class: "doc-info" }
const _hoisted_21 = { class: "doc-title" }
const _hoisted_22 = { class: "doc-name" }
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = { class: "doc-details" }
const _hoisted_25 = { class: "doc-size" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-complete" }, "Uploaded", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-status" }, "2 seconds left", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-percent" }, "64%", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "doc-progress" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "upload-progress" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.getDocumentsUploaded.length || _ctx.getUploadFiles.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.getTotalFiles > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getUploadedFiles) + " of " + _toDisplayString(_ctx.getTotalFiles) + " Uploading ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUploadFiles.filter((f) => f.show), (file, fIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "document-li active",
              key: fIndex
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    alt: file.name,
                    src: require(`../../assets/images/${_ctx.getExtIcon(file.type)}`)
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(file.name), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "doc-close btn btn-secondary",
                      disabled: file.disabled,
                      onClick: ($event: any) => (_ctx.cancelUploading(fIndex))
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatBytes(file.size)), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getUploadProgress[fIndex]?.time) + " seconds left ", 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getUploadProgress[fIndex]?.progress) + "% ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "upload-progress",
                  style: _normalizeStyle(`width: ${_ctx.getUploadProgress[fIndex]?.progress}%`)
                }, null, 4)
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDocumentsUploaded, (file) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "document-li",
              key: 'file-' + file.electionUploadId
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("img", {
                    alt: file.fileName,
                    src: 
                require(`../../assets/images/${_ctx.getExtIcon(file.contentType)}`)
              
                  }, null, 8, _hoisted_19)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(file.fileName), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "doc-close btn btn-secondary",
                      disabled: file.disabled,
                      onClick: ($event: any) => (_ctx.deleteDocument(file.electionUploadId)),
                      "aria-label": "Close"
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatBytes(file.fileSize)), 1),
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28
                  ])
                ])
              ]),
              _hoisted_29
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}